import type { Prototype } from "../prototype-types";

export const henryBullinghamPrototypes: Prototype[] = [
  {
    id: "hbul-dormant-products",
    name: "Dormant Products",
    path: "/hbul/dormant-products",
    description:
      "Inventory and products surfaces exploring dormant vs active OOS splits, plus OOS count surfaces (false OOS, recently OOS, retailer requests, still OOS 90+).",
    owner: "Henry Bullingham",
    createdAt: "2026-08-12",
    lastUpdated: "2026-08-20",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1619d3a1fcfa0e6bc620102bf85f9325f8e0e45f15052800017e1e515185f6e3.png",
    creationTool: "claude-code",
  },
  {
    id: "hbul-allow-delete-product-with-open-invoice",
    name: "Allow Delete Product With Open Invoice",
    path: "/hbul/allow-delete-product-with-open-invoice",
    description:
      "Baseline flow when deleting a product or variant that is included on an open invoice — surfaces the current blocking error.",
    owner: "Henry Bullingham",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-14",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a016ec779af81d6da73bc9a3b72f2edfbee6d432b6861e3ffd46b49157a743bb.png",
    creationTool: "claude-code",
  },
];
